// src/utils/isAdmin.js
//
// Single source of truth for "is this Firebase user an admin?"
// The server enforces this independently via ADMIN_EMAILS env var; the frontend
// only uses this to hide UI elements and short-circuit redirects.
//
// To support additional admins later, add to ADMIN_EMAILS here AND on the
// server systemd unit. Keep them in sync.

const ADMIN_EMAILS = (process.env.REACT_APP_ADMIN_EMAILS || 'ali.mkia88@gmail.com')
  .toLowerCase()
  .split(',')
  .map((e) => e.trim())
  .filter(Boolean);

export function isAdmin(user) {
  if (!user || !user.email) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
}

export { ADMIN_EMAILS };
